import { moment } from "@/services/vue-moment";

export var date = d => {
  return new Promise(resolve => {
    resolve(
      moment
        .utc(d)
        .local()
        .format()
    );
  });
};

export var resource = r => {
  var res = {};
  return new Promise(resolve => {
    Promise.all([
      r.created_at ? date(r.created_at) : Promise.resolve(""),
      r.updated_at ? date(r.updated_at) : Promise.resolve(""),
      r.deleted_at ? date(r.deleted_at) : Promise.resolve("")
    ]).then(values => {
      res.creation = values[0];
      res.modification = values[1];
      res.deletion = values[2];
      delete res.created_at;
      delete res.updated_at;
      delete res.deleted_at;
      resolve(res);
    });
  });
};

export default {
  date
};
